import { Component, OnInit } from '@angular/core';
declare var $:any;
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-helpvideos',
  templateUrl: './helpvideos.component.html',
  styleUrls: ['./helpvideos.component.css']
})
export class HelpvideosComponent implements OnInit {
video_link;
 vid_name;
 blog_list;
 content;
 view_data = false;
 pageLimit = 8;
 paginationData:any ={"info":"hide"};
 offset_count :number = 0;
 recordNotFound = false;
 customer_id;
  constructor(private router:Router,public serverService: ServerService) { }

  ngOnInit(): void {
    this.get_blogdata({});
  }



// showvid(x,y){

// }

  showvid(link,name){  
    var url= link.split('/');
    //alert(url[3]); 
    this.video_link="https://www.youtube.com/embed/"+url[3];
    this.vid_name=name;
    //alert(this.video_link);
    // $("#video_play").model('show');
    $("#video_play").modal('show');
   // $('#video_play').modal('hide');
  }

get_blogdata(data){

  var list_data= this.listDataInfo(data);
  this.customer_id =localStorage.getItem('en');
  let api_req:any = '{"operation":"blog","moduleType":"blog","api_type":"web","element_data":{"customer_id":"'+this.customer_id+'","limit":"'+list_data.limit+'","action":"blog_lists","offset":"'+list_data.offset+'"}}';
  this.serverService.sendServer(api_req).subscribe((response: any) => {
    console.log(response)
            if(response.status=='true'){
              this.blog_list = response.post_list;
              console.log(this.blog_list)
              this.offset_count = list_data.offset;
              console.log(this.offset_count)
              this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
               console.log(this.paginationData);
                      this.recordNotFound = this.blog_list.length == 0 ? true : false;

            }else{
            }
          }, 
          (error)=>{
              console.log(error);
          });
}
replace(content){
return "<p>"+content+"</p>";
}
listDataInfo(list_data){
  console.log(list_data)
    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
    // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
    list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  } 

}
